var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.options,"rules":[_vm.rules.required],"menu-props":{ maxHeight: '400' },"multiple":_vm.isMultiple,"placeholder":_vm.sampleInput,"solo":"","dense":"","flat":"","outlined":"","clearable":""}})}
var staticRenderFns = []

export { render, staticRenderFns }